import React from 'react';
import Testimonials from '../components/Testimonials';
import '../styles/testimonials-page.css';

const TestimonialsPage: React.FC = () => {
    return (
        <main id="main-content" className="testimonials-page" aria-label="Página de depoimentos dos professores">
            <div className="page-hero">
                <h1>Mensagens dos Professores</h1>
                <p className="hero-subtitle">
                    Palavras de carinho, inspiração e gratidão dos nossos mestres
                </p>
            </div>
            <Testimonials />
        </main>
    );
};

export default TestimonialsPage;